import { APP_TYPE, AppType } from "../../app.type";
import { Inject, Injectable } from "@angular/core";
import { getAllManufacturersCodesDocs } from "../../api.service";
import { ManufacturerCodeServiceType } from "./manufacturer-code.service.type";
import { ManufacturerCode } from "../../../../../shared/models/manufacturerCode";

@Injectable()
export class ManufacturerCodeService implements ManufacturerCodeServiceType {
  constructor(@Inject(APP_TYPE) private app: AppType) {}
  allManufacturerDocs: ManufacturerCode[] = [];

  async generateManufacturerNames(docs: ManufacturerCode[]) {
    this.allManufacturerDocs = await getAllManufacturersCodesDocs();
    const documents: ManufacturerCode[] = [];
    docs.forEach(async (doc) => {
      const manufacutrerCode = new ManufacturerCode();
      /** check if exists in the already created documents */
      const duplicateDoc = documents.find(
        (e) => e["manufacturerName"] === doc["manufacturerName"]
      );

      this.app.import.props.forEach((field) => {
        const fieldName = doc[field.key];
        if (fieldName != null) {
          if (field.key === "cageCode") {
            manufacutrerCode[field.key] = [fieldName];
          } else {
            if (duplicateDoc != null) {
              duplicateDoc["cageCode"] = duplicateDoc["cageCode"].concat(
                doc["cageCode"]
              );
            } else {
              manufacutrerCode[field.key] = fieldName;
            }
          }
        }
      });
      manufacutrerCode.type = "manufacturerCode";
      delete manufacutrerCode._id;
      if (duplicateDoc == null) {
        documents.push(manufacutrerCode);
      }
    });

    if (this.allManufacturerDocs != null) {
      docs = this.updateExistingManufacturerCode(documents);
    } else {
      docs = documents;
    }

    this.app.import.docs = docs;
    (docs as []).forEach((doc: any) => {
      this.app.import.selected.add(doc.manufacturerName);
    });

    this.app.import.stepper = "reviewList";
    this.app.import.step = "third";
    return this.app.import.docs;
  }

  updateExistingManufacturerCode(documents: ManufacturerCode[]) {
    const updatedDocs: ManufacturerCode[] = [];
    documents.forEach((doc: ManufacturerCode) => {
      const index = this.allManufacturerDocs.findIndex(
        (d) => d.manufacturerName === doc.manufacturerName
      );
      // Update existing manufacturer code doc
      if (index !== -1) {
        const existingDoc = this.allManufacturerDocs[index];
        if (
          existingDoc["cageCode"].toString() != doc["cageCode"].toString() &&
          existingDoc["manufacturerName"] === doc["manufacturerName"]
        ) {
          doc._id = existingDoc._id;
          doc._rev = existingDoc._rev;
          updatedDocs.push(doc);
        }
      } else {
        // Create new manufacturer code doc
        updatedDocs.push(doc);
      }
    });

    return updatedDocs;
  }
}
